import React, { ReactNode, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useExpanded, useGlobalFilter, useSortBy, useTable } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown, faEye } from '@fortawesome/free-solid-svg-icons';

interface ICustomTable {
  scope?: any;
  columns: any;
  row?: number;
  invalidUser?: boolean;
  viewData?: boolean;
  data: any;
  invalidRows?: number[];
  search?: string;
  footer?: ReactNode;
  setViewData?: (x: boolean | undefined) => void;
  onRowClick?: (x: number) => void;
  getClass?: (x: any, y: number) => void;
}

const CustomTable: React.FC<ICustomTable> = ({
  scope,
  columns,
  data,
  row,
  footer,
  invalidUser,
  viewData,
  invalidRows,
  setViewData,
  onRowClick,
  search,
}) => {
  const [rowSelect, setRowSelect] = useState(row);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setGlobalFilter } = useTable(
    { columns, data },
    useGlobalFilter,
    useSortBy,
    useExpanded,
  );

  useEffect(() => {
    setGlobalFilter(search);
  }, [search]);

  useEffect(() => {
    setRowSelect(row);
  }, [row]);

  return (
    <div>
      <Table striped bordered {...getTableProps()} className={`table-sm ${invalidUser ? 'table-danger' : ''}`}>
        <thead>
          {headerGroups.map((headerGroup, index) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={index} className="table-header-gray">
              {headerGroup.headers.map((column, index) => {
                const sortProps = column.canSort
                  ? column.getHeaderProps(column.getSortByToggleProps())
                  : column.getHeaderProps();
                return (
                  <th {...sortProps} key={index} className="table-head-font-size">
                    {column.render('Header')}
                    <span className="cursor-pointer" onClick={() => setViewData && setViewData(!viewData)}>
                      {column.id == 'hidden' && <FontAwesomeIcon icon={faEye} className="ms-2" />}
                    </span>
                    <span>
                      {column.canSort ? (
                        column.isSorted ? (
                          column.isSortedDesc ? (
                            <FontAwesomeIcon icon={faSortUp} className="ms-2" />
                          ) : (
                            <FontAwesomeIcon icon={faSortDown} className="ms-2" />
                          )
                        ) : (
                          <FontAwesomeIcon icon={faSort} className="ms-2" />
                        )
                      ) : null}
                    </span>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row: any, i) => {
            prepareRow(row);
            return (
              <React.Fragment key={i}>
                <tr
                  {...row.getRowProps()}
                  className={`table-body-font-size ${rowSelect && row.id === rowSelect ? 'table-info' : ''} ${invalidRows && invalidRows?.length > 0 && invalidRows.includes(Number(row.id)) ? 'table-danger' : ''}`}
                >
                  {row.cells.map((cell: any, index: number) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        key={index}
                        style={{
                          border: 'none',
                          backgroundColor: !scope && scope === 'Management' && '#fff',
                        }}
                        className={'text-dark align-middle'}
                        onClick={() => onRowClick}
                      >
                        {cell.column.id !== 'hidden' || viewData ? cell.render('Cell') : '**********'}
                      </td>
                    );
                  })}
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>{footer}</tfoot>
      </Table>
    </div>
  );
};

export default CustomTable;
